import { encodeArrayBufferToBase64 } from './helpers';

export const encryptByRSA = async (key: string, value: string) => {
  //* Convert base64-encoded public key to Uint8Array
  const keyBytes = new Uint8Array(
    window
      .atob(key)
      .split('')
      .map((char) => char.charCodeAt(0))
  );

  //* Import public key
  const importedKey = await window.crypto.subtle.importKey(
    'spki',
    keyBytes,
    { name: 'RSA-OAEP', hash: { name: 'SHA-256' } },
    false,
    ['encrypt']
  );

  //* Convert message to Uint8Array
  const messageBuffer = new TextEncoder().encode(value);

  //* Encrypt the message
  const encryptedData = await window.crypto.subtle.encrypt(
    { name: 'RSA-OAEP' },
    importedKey,
    messageBuffer
  );

  const base64Encoded = encodeArrayBufferToBase64(encryptedData);

  return base64Encoded;
};
